import React from "react";

interface ActivityLogTableProps {
  exercises: any[];
  exerciseResults: Record<string, any>;
  onEdit: (idx: number) => void;
}

export function ActivityLogTable({ exercises, exerciseResults, onEdit }: ActivityLogTableProps) {
  return (
    <table className="min-w-full divide-y divide-gray-200">
      <thead>
        <tr>
          <th className="px-4 py-2">Exercise</th>
          <th className="px-4 py-2">Type</th>
          <th className="px-4 py-2">Sets</th>
          <th className="px-4 py-2">Completed</th>
          <th className="px-4 py-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        {exercises.map((ex, idx) => {
          const result = exerciseResults[ex.id] || {};
          return (
            <tr key={ex.id}>
              <td className="px-4 py-2">{ex.name}</td>
              <td className="px-4 py-2">{ex.type}</td>
              <td className="px-4 py-2">{ex.structure?.sets || '-'}</td>
              <td className="px-4 py-2">{result.completed ? "Yes" : "No"}</td>
              <td className="px-4 py-2">
                <button className="text-blue-500 underline" onClick={() => onEdit(idx)}>
                  Edit
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
